module.exports = __webpack_public_path__ + "img/ly.89b78875.png";